export default {
  FIRST_TAB_ID: 1,
  SECOND_TAB_ID: 2,
  THIRD_TAB_ID: 3,
};
